const keyMirror = require('key-mirror');

export default keyMirror({
  LOTS_REQUESTED: null,
  LOTS_LOADED_SUCCESSFUL: null,
  LOTS_LOAD_ERROR: null,
  
  LOT_RISE_OF_REQUESTED: null,
  LOT_RISE_OF_SUCCESSFUL: null,
  LOT_RISE_OF_ERROR: null,

  UPDATE_LOTE: null,

  REMOVE_LOTE_REQUESTED: null,
  REMOVE_LOTE_SUCCESSFUL: null,
});


// WEBPACK FOOTER //
// ./src/pages/BIDS_PAGE/actions/actions.js